import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

/**
 * ĐỌC sổ hạn cũng phải có quyền — khác trang Chi phí, nơi mọi người đăng nhập
 * đều đọc được. Sổ này mang điều khoản thuê và tiền cọc của cả chuỗi.
 */
export function canReadObligations(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.ObligationRead);
}

export function canWriteObligations(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.ObligationWrite);
}

/**
 * Đèn hệ thống hẹp hơn sổ hạn: kế toán và trưởng cửa hàng cần biết ngày hết
 * hạn hợp đồng, nhưng sức khoẻ hạ tầng là việc của người điều hành toàn chuỗi.
 */
export function canReadSystemHealth(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.SystemHealthRead);
}
